export const DEFAULT_PAGE = '/products-and-services/parcel-delivery/uk/';
export const DEFAULT_COUNTRY = 'GB';
export const DEFAULT_BUS_ZONE = '^1000';

export const DOMESTIC_SERVICES = {
  PARCEL_BY_10_30: 'Parcel By 10:30',
  TWO_DAY_PARCEL: 'Two day Parcel',
  PARCEL_NEXT_DAY: 'Parcel Next Day',
  PARCEL_BY_12: 'Parcel By 12',
  PARCEL_SUN_BY_12: 'Parcel Sun By 12',
  PARCEL_SAT_BY_12: 'Parcel Sat By 12',
  PARCEL_SATURDAY: 'Parcel Saturday',
  PARCEL_SUNDAY: 'Parcel Sunday',
  SHIP_TO_SHOP: 'Ship2Shop',
};
